/*
 * @Description:
 * @Author: didan
 * @Date: 2023-12-06 16:30:24
 * @LastEditTime: 2025-04-09 15:29:23
 * @LastEditors: didan
 */
import { get, post, deleted, prefix, prefixAi } from './base';

// 获取待导入的任务
export function getTaskList(params) {
  return post(`${prefix}api/ai/waybill/lastTaskInfo`, params);
}
// 导入运单
export function importWaybill(params) {
  return post(`${prefix}api/ai/waybill/importWaybill`, params);
}
//根据任务id获取导入任务信息
export function getAiImportTaskInfo(params) {
  return post(`${prefix}api/ai/waybill/getAiImportTaskInfo`, params);
}
// 获取已处理的运单列表
export function getWaybillList(params) {
  return post(`${prefix}api/ai/waybill/listTaskInfo`, params);
}
// 下载失败运单
export function downloadFailWaybill(params) {
  return get(`${prefix}api/ai/waybill/downloadWaybillList`, params);
}
// 上传运单列表修改运单信息
export function uploadWaybillList(params) {
  return post(`${prefix}api/ai/waybill/uploadWaybillList`, params);
}
// 获取企业智能录单的配置列表
export function aiCorporationConfigInfoList(params) {
  return post(`${prefix}api/ai/waybill/aiCorporationConfigInfoList`, params);
}

// 修改企业智能录单的配置
export function updateAiCorporationConfigInfo(params) {
  return post(`${prefix}api/ai/waybill/updateAiCorporationConfigInfo`, params);
}

// 操作智能录单自有车
export function operateAiOwnVehicle(params) {
  return post(`${prefix}api/ai/waybill/operateAiOwnVehicle`, params);
}

// 获取智能录单自有车列表
export function aiOwnVehicleList(params) {
  return post(`${prefix}api/ai/waybill/aiOwnVehicleList`, params);
}

export function downloadOwnVehicleExcelTemplate(params) {
  return get(`${prefix}/api/ai/waybill/downloadOwnVehicleExcelTemplate`, params);
}
export function uploadOwnVehicleExcel(params) {
  return post(`${prefix}api/ai/waybill/uploadOwnVehicleExcel`, params);
}
export function getRecordConfiguration(params) {
  return post(`${prefix}api/ai/waybill/dataDictionary`, params);
}
export function getAiCorporationConfigInfo(params) {
  return post(`${prefix}api/ai/waybill/aiCorporationConfigInfoV2`, params);
}
export function modifyAiCorporationConfigInfo(params) {
  return post(`${prefix}api/ai/waybill/modifyAiCorporationConfigInfo`, params);
}

/**
 * 运单数据明细列表 - 运单分页查询接口
 * @param {Object} params - 查询参数
 * @param {string} params.thirdTenantCode - 第三方租户编码 (必填)
 * @param {string} [params.appConfigId] - 应用配置id
 * @param {number} params.page - 当前页码 (必填)
 * @param {number} params.size - 每页条数 (必填)
 * @param {string} [params.loadingTimeStart] - 装货开始时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.loadingTimeEnd] - 装货结束时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.sendProvince] - 装货省
 * @param {string} [params.sendCity] - 装货市
 * @param {string} [params.sendDistrict] - 装货区县
 * @param {string} [params.receiveProvince] - 卸货省
 * @param {string} [params.receiveCity] - 卸货市
 * @param {string} [params.receiveDistrict] - 卸货区县
 * @param {string} [params.goodsName] - 货物名称
 * @param {string} [params.goodsPacking] - 货物包装方式
 * @param {string} [params.goodsCategory] - 货物类别
 * @param {string} [params.vehicleType] - 车辆类型
 * @returns {Promise<{
 *   code: string,
 *   message: string,
 *   data: {
 *     pageNo: number,
 *     pageSize: number,
 *     total: string,
 *     list: Array<{
 *       id: string,
 *       taskId: string,
 *       waybillNo: string,
 *       sourceType: number,
 *       customerId: string,
 *       appConfigId: string,
 *       customerName: string,
 *       sendProvince: string,
 *       sendCity: string,
 *       sendDistrict: string,
 *       sendAddress: string,
 *       receiveProvince: string,
 *       receiveCity: string,
 *       receiveDistrict: string,
 *       receiveAddress: string,
 *       goodsName: string,
 *       goodsType: string,
 *       goodsCategory: string,
 *       goodsPacking: string,
 *       sendQuantity: string,
 *       sendQuantityUnit: string,
 *       contactName: string,
 *       contactPhone: string,
 *       freight: string,
 *       loadingTime: string,
 *       unloadingTime: string,
 *       waybillContent: string,
 *       vehicleType: string,
 *       isDelete: number,
 *       createTime: string,
 *       updateTime: string
 *     }>
 *   },
 *   lid: string
 * }>}
 */
export function getWaybillDataList(params) {
  return post(`${prefixAi}waybill/common/pageQueryWaybills`, params);
}

/**
 * 运单数据统计分析 - 运单数据统计（按天）查询接口
 * 包含: 热门运输路线TOP5、区域运输量分布、货物类别分析
 * @param {Object} params - 查询参数
 * @param {string} params.tenantCode - 租户编码 (必填)
 * @param {string} params.date - 统计日期 (格式: YYYY-MM-DD) (必填)
 * @returns {Promise<{
 *   code: string,
 *   message: string,
 *   data: Array<{
 *     id: string,
 *     recordDate: string,
 *     customerId: string,
 *     appConfigId: string,
 *     customerName: string,
 *     totalCount: number,
 *     eventType: number,
 *     eventInfo: Array<{
 *       eventKey: string,
 *       eventCount: string,
 *       eventValue: string
 *     }>
 *   }>,
 *   lid: string
 * }>}
 * @description
 * - eventType 说明: 1-热门运输线路, 2-区域运输量(始发地), 3-货物类别分类
 * - totalCount: 当日运单录入总量，用于计算饼状图比例
 * - eventInfo: 具体事件数据数组
 */
export function getWaybillDataStatistics(params) {
  return get(`${prefixAi}waybill/common/statistics/daily`, params);
}

/**
 * 获取运单数据字典 - 类型字典枚举下拉选公共查询接口
 * @param {Object} params - 查询参数
 * @param {string} params.tenantCode - 租户编码 (必填)
 * @param {number} [params.type] - 字典类型：1-货物包装方式, 2-货物类别, 3-车辆类型 (不填默认返回所有类型)
 * @returns {Promise<{
 *   code: string,
 *   message: string,
 *   data: Array<{
 *     key: number,
 *     value: string,
 *     type: number
 *   }>,
 *   lid: string
 * }>}
 * @description type 说明: 1-货物包装方式, 2-货物类别, 3-车辆类型
 */
export function getWaybillDataDictionary(params) {
  return get(`${prefixAi}waybill/common/dicTypeList`, params);
}

/**
 * 导出运单数据明细 - 运单数据导出接口
 * @param {Object} params - 导出参数（与查询参数一致）
 * @param {string} params.thirdTenantCode - 第三方租户编码 (必填)
 * @param {string} [params.loadingTimeStart] - 装货开始时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.loadingTimeEnd] - 装货结束时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.unloadingTimeStart] - 卸货开始时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.unloadingTimeEnd] - 卸货结束时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.sendProvince] - 装货省
 * @param {string} [params.sendCity] - 装货市
 * @param {string} [params.sendDistrict] - 装货区县
 * @param {string} [params.receiveProvince] - 卸货省
 * @param {string} [params.receiveCity] - 卸货市
 * @param {string} [params.receiveDistrict] - 卸货区县
 * @param {string} [params.goodsName] - 货物名称
 * @param {string} [params.goodsPacking] - 货物包装方式
 * @param {string} [params.goodsCategory] - 货物类别
 * @param {string} [params.vehicleType] - 车辆类型
 * @returns {String} 导出URL
 */
export const exportWaybillDataExcel = `${prefixAi}waybill/common/exportQueryWaybills`;

/**
 * 获取省市区数据 - 行政区县查询接口
 * @param {Object} [params] - 查询参数
 * @param {string} [params.province] - 省份名称（可选，用于查询指定省份下的城市）
 * @param {string} [params.city] - 城市名称（可选，用于查询指定城市下的区县）
 * @returns {Promise<{
 *   code: string,
 *   message: string,
 *   desc: string,
 *   data: Array<{
 *     code: string,
 *     name: string,
 *     level: string,
 *     districts: Array<{
 *       code: string,
 *       name: string,
 *       level: string,
 *       districts: Array
 *     }>
 *   }>,
 *   lid: string
 * }>}
 * @description
 * - level 说明: province-省份, city-市, district-区县
 * - districts 是嵌套的对象数组，包含下级行政区划
 */
export function getCityData(params = {}) {
  return get(`${prefixAi}waybill/common/district`, params);
}
